module.exports = __webpack_public_path__ + "fonts/a536642f/proxima_nova_bold-punc.ttf";